import { render, staticRenderFns } from "./picture-img.vue?vue&type=template&id=c4f5505e&scoped=true&"
import script from "./picture-img.vue?vue&type=script&lang=js&"
export * from "./picture-img.vue?vue&type=script&lang=js&"
import style0 from "./picture-img.vue?vue&type=style&index=0&id=c4f5505e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f5505e",
  null
  
)

export default component.exports